<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <path d="M497,192c8.284,0,15-6.716,15-15V25c0-8.284-6.716-15-15-15H255c-8.284,0-15,6.716-15,15v152c0,8.284,6.716,15,15,15h106v50H15c-8.284,0-15,6.716-15,15v230c0,8.284,6.716,15,15,15h482c8.284,0,15-6.716,15-15V257c0-8.284-6.716-15-15-15H391v-50H497zM482,472H30v-40h452V472z M482,272v130H30V272H482z M270,162V40h212v122H270z"/>
  <path d="M447,60H305c-8.284,0-15,6.716-15,15v52c0,8.284,6.716,15,15,15h142c8.284,0,15-6.716,15-15V75C462,66.716,455.284,60,447,60z M432,112H320V90h112V112z"/>
</svg>
</template>
